/**
 * Returns the lower-cased extension of the given file name, without the dot.
 * File names in the portal are sometimes URL encoded, so the name is decoded
 * first (falling back to the raw name when decoding throws), and any query
 * string or fragment that was carried along is ignored.
 */
export function getFileExtension(fileName: string | undefined | null): string | undefined {
  if (!fileName) return undefined

  let name = fileName
  try {
    name = decodeURIComponent(fileName)
  } catch (e) {
    // leave as-is
  }

  name = name.split(/[?#]/)[0].trim()

  const match = /\.([^./\\]+)$/.exec(name)
  return match ? match[1].toLowerCase() : undefined
}
